import "./stepper.scss"

/**
 * Compact -/+ number stepper for small bounded values (e.g. room quantity,
 * sleeps). Deliberately tiny so it sits inline on a row without the height of a
 * full labelled input. `onChange` receives the new (clamped) number.
 *
 * The buttons stop propagation so the stepper can live inside a clickable row
 * without toggling it.
 */
export default function Stepper({ value, min = 0, max = null, step = 1, onChange, ariaLabel = "" }) {
	const num = Number(value) || 0

	const commit = (next) => {
		let clamped = next
		if (min !== null) clamped = Math.max(min, clamped)
		if (max !== null) clamped = Math.min(max, clamped)
		if (onChange) onChange(clamped)
	}

	const atMin = min !== null && num <= min
	const atMax = max !== null && num >= max

	return (
		<div className="ui-stepper">
			<button
				type="button"
				className="ui-stepper-btn"
				aria-label={`Decrease ${ariaLabel}`.trim()}
				disabled={atMin}
				onClick={(event) => {
					event.stopPropagation()
					commit(num - step)
				}}>
				&minus;
			</button>
			<span className="ui-stepper-val">{num}</span>
			<button
				type="button"
				className="ui-stepper-btn"
				aria-label={`Increase ${ariaLabel}`.trim()}
				disabled={atMax}
				onClick={(event) => {
					event.stopPropagation()
					commit(num + step)
				}}>
				+
			</button>
		</div>
	)
}
